// When adding new cases make sure to add to en.lyaml chat.copilotName.<newAssistantType>
export const BREEZE_COPILOT = 'breezeCopilot';
export const SALES_COPILOT = 'salesCopilot';
// TODO: REMOVE THIS - as its not longer an assistant
export const INTERACTIVE_MODE = 'interactiveMode';
export const CHAT_AGENT = 'chatAgent';